/**
 * @generated SignedSource<<b925ad6aa71976dfa398ecf5f6e071ef>>
 * @relayHash d4bb2f70e3f245949e51ed9fd8edb969
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80ce14c9c604df700aa1edce29c418e660a1a9923e23a3b235284531292c200b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NotificationsPageQuery$variables = {
  cloudId: string;
};
export type NotificationsPageQuery$data = {
  readonly jira: {
    readonly notificationGlobalPreference: {
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"notificationPreferencesOptionsWrapper_PersonalSettingsPreferenceFields_NotificationPreferencesOptions">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"GlobalNotificationConfigTableNew">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProjectNotificationsConfig_personalSettingsNotificationsConfigTable_projects">;
};
export type NotificationsPageQuery = {
  response: NotificationsPageQuery$data;
  variables: NotificationsPageQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider: {
    readonly get: () => boolean;
  };
});

import includeMiscellaneousCombinedType_provider from '@jira/platform__graphql-relay-provider/src/include-miscellaneous-events-combined-type.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "concreteType": "JiraAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "xsmall"
      }
    ]
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v7 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "category"
  }
],
v8 = {
  "concreteType": "JiraNotificationPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueAssigned",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueUpdated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueDeleted",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentCreated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentEdited",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentDeleted",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueCreated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueMoved",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "mentionsCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "worklogCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "miscellaneousIssueEventCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "spaceAccessRequestNotification",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "NotificationsPageQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ProjectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraNotificationGlobalPreference",
                "kind": "LinkedField",
                "name": "notificationGlobalPreference",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "GlobalNotificationConfigTableNew"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraNotificationOptions",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "notificationPreferencesOptionsWrapper_PersonalSettingsPreferenceFields_NotificationPreferencesOptions"
                        }
                      ]
                    },
                    "action": "THROW"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "NotificationsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraNotificationProjectPreferenceConnection",
            "kind": "LinkedField",
            "name": "allNotificationProjectPreferences",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectNotificationPreferenceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraNotificationProjectPreferences",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalCount"
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              (v9/*: any*/)
            ]
          },
          {
            "args": (v3/*: any*/),
            "filters": [
              "cloudId"
            ],
            "handle": "connection",
            "key": "projects_allNotificationProjectPreferences",
            "kind": "LinkedHandle",
            "name": "allNotificationProjectPreferences"
          },
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraNotificationGlobalPreference",
            "kind": "LinkedField",
            "name": "notificationGlobalPreference",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isEmailNotificationEnabled"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "notifyWhenRoleAssigneeEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "notifyWhenRoleReporterEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "notifyOwnChangesEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "batchWindow"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "dailyBatchLocalTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "emailMimeType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEmailMimeTypeEditable"
                  }
                ]
              },
              (v8/*: any*/)
            ]
          },
          {
            "alias": "allJiraProjectsForModal",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "notificationConfigurationState": "DEFAULT",
                  "sortBy": {
                    "sortBy": "NAME"
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "80ce14c9c604df700aa1edce29c418e660a1a9923e23a3b235284531292c200b",
    "metadata": {},
    "name": "NotificationsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
    }
  }
};
})();

(node as any).hash = "cb87ee61d21ee84bd18461e4e639ea01";

export default node;
